// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__ziP8Q","alert":"SettungsInbox_alert__3Pcs0"};